import $ from "jquery";

const Grid = {
	breakpoints: {
		xs: 0,
		sm: 640,
		md: 768,
		lg: 1024,
		xl: 1280,
	},

	current: null,

	// Calculate current brakpoint
	getCurrentBreakpoint() {
		let breakpoints = Object.keys(Grid.breakpoints);
		for (let index in breakpoints) {
			let name = breakpoints[index];
			let breakpoint = Grid.breakpoints[name];

			// Simulate Bootstrap media queries
			if (index !== "0" && window.matchMedia("(max-width: " + (breakpoint - .02) + "px)").matches)
				return breakpoints[index-1];
		}

		return "xl";
	},

	// Match current breakpoint against a given one
	is(breakpoint) {
		return Grid.current === breakpoint;
	},

	// Check if current breakpoint is equal or smaller than given
	isOrSmaller(breakpoint) {
		return Grid.breakpoints[Grid.current] <= Grid.breakpoints[breakpoint];
	},

	// Check if current breakpoint is equal or larger than given
	isOrLarger(breakpoint) {
		return Grid.breakpoints[Grid.current] >= Grid.breakpoints[breakpoint];
	},

	// Window resize callback
	resize(e) {
		let newBreakpoint = Grid.getCurrentBreakpoint();

		// Breakpoint has changed
		if (newBreakpoint !== Grid.current) {
			Grid.current = newBreakpoint;

			// Trigger breakpoint change event
			if (e)
				$(window).trigger("grid-breakpoint-change", [ newBreakpoint ]);
		}


		// Trigger window resized event
		if (e)
			setTimeout(() => {
				$(window).trigger("grid-resized", [ newBreakpoint, $(e.target).width() ]);
			}, 100);
	}
};

$(window).on("resize", Grid.resize);
Grid.resize();

export default Grid;
